import { query } from '@angular/animations';
import { environment } from '../../environments/environment';
export const API_END_POINTS = {
  AUTH: {
    signin: `${environment.APIBaseUrl}/users/signin`,
    resendOtp: `${environment.APIBaseUrl}/users/signin/otp/resend`,
    sendOtp: `${environment.APIBaseUrl}/users/signin/mobile/verify`,
    login: `${environment.APIBaseUrl}/authz`,
    sendAppLink: `${environment.APIBaseUrl}/clients/sms`,
    contactUs: `${environment.APIBaseUrl}/clients/contact_us`,
    topPerformer: `${environment.APIBaseUrl}/clients/advisors/top/performer/list`,
    market_time: `${environment.APIBaseUrl}/investpack/market/hours`,
    auth_security: `${environment.APIBaseUrl}/clients/security`,
    user_device: `${environment.APIBaseUrl}/users/signin/device-token`,
    login_flow: `${environment.APIBaseUrl}/users/signin/login-flow`
  },
  ALICE_BLUE: {
    signinWith: `${environment.APIBaseUrl}/aliceblue/signin`,
    loginWith: `${environment.APIBaseUrl}/aliceblue/login`,
    client: `${environment.APIBaseUrl}/aliceblue/client`,
    placeOrder: `${environment.APIBaseUrl}/aliceblue/orders`,
    token_info: `${environment.APIBaseUrl}/aliceblue/jwt`,
    bracket_order: `${environment.APIBaseUrl}/aliceblue/orders/bracket`,
    strategy_order: `${environment.APIBaseUrl}/aliceblue/orders/strategic`,
  },
  MASTER_TRUST: {
    signinWith: `${environment.APIBaseUrl}/mastertrust/signin`,
    loginWith: `${environment.APIBaseUrl}/mastertrust/login`,
    client: `${environment.APIBaseUrl}/mastertrust/client`,
    token_info: `${environment.APIBaseUrl}/mastertrust/jwt`,
    placeOrder: `${environment.APIBaseUrl}/mastertrust/orders`,
    bracket_order: `${environment.APIBaseUrl}/mastertrust/orders/bracket`,
    strategy_order: `${environment.APIBaseUrl}/mastertrust/orders/strategic`,
  },
  TRADE_SMART: {
    placeOrder: `${environment.APIBaseUrl}/tradesmart/orders`,
    bracket_order: `${environment.APIBaseUrl}/tradesmart/orders/bracket`,
    login: `${environment.APIBaseUrl}/tradesmart/login/submit/details`,
    signin: `${environment.APIBaseUrl}/tradesmart/signin`,
    strategy_order: `${environment.APIBaseUrl}/tradesmart/orders/strategic`,
  },
  FIVE_PAISA: {
    client: `${environment.APIBaseUrl}/fivepaisa/client`,
    token_info: `${environment.APIBaseUrl}/fivepaisa/jwt`,
    submit_details: `${environment.APIBaseUrl}/fivepaisa/login/submit/details`,
    signinWith: `${environment.APIBaseUrl}/fivepaisa/signin`,
    loginWith: `${environment.APIBaseUrl}/fivepaisa/login`,
    placeOrder: `${environment.APIBaseUrl}/fivepaisa/orders`,
    connect_signin: `${environment.APIBaseUrl}/fivepaisa/signin/connect`,
    strategy_order: `${environment.APIBaseUrl}/fivepaisa/orders/strategic`
  },
  FINVASIA: {
    signin: `${environment.APIBaseUrl}/finvasia/finvasia/signin`,
    login: `${environment.APIBaseUrl}/finvasia/finvasia/login`
  },
  ZEBU: {
    redirect: `${environment.APIBaseUrl}/zebu/trade/redirect`,
    signin: `${environment.APIBaseUrl}/zebu/trade/singIn`,
    login: `${environment.APIBaseUrl}/zebu/trade/login`
  },
  UPSTOX: {
    client_url: `${environment.APIBaseUrl}/upstox/v2/redirect`,
    placOrder: `${environment.APIBaseUrl}/upstox/v2/placed/orders`,
    signin: `${environment.APIBaseUrl}/upstox/v2/singUp`,
    login: `${environment.APIBaseUrl}/upstox/v2/login`
  },
  PAYTM: {
    redirect: `${environment.APIBaseUrl}/paytm/money/redirect`,
    signin: `${environment.APIBaseUrl}/paytm/money/signIn`,
    login: `${environment.APIBaseUrl}/paytm/money/login`
  },
  INVESTOR: {
    users: `${environment.APIBaseUrl}/users/investors`,
    upload: `${environment.APIBaseUrl}/users/investors/upload`,
    email: `${environment.APIBaseUrl}/users/investors/email`,
    emailVerify: `${environment.APIBaseUrl}/users/investors/email/verify`,
    mobile: `${environment.APIBaseUrl}/users/investors/mobile`,
    verifyMobile: `${environment.APIBaseUrl}/users/investors/mobile/verify`,
    password: `${environment.APIBaseUrl}/users/investors/change/password`,
    newCall: `${environment.APIBaseUrl}/calls/investors/dashboard/new/calls`,
    myCall: `${environment.APIBaseUrl}/calls/investors/dashboard/my/calls`,
    watchCall: `${environment.APIBaseUrl}/calls/investors/dashboard/watch/calls`,
    closedCall: `${environment.APIBaseUrl}/calls/investors/dashboard/closed/calls`,
    followAdvisor: `${environment.APIBaseUrl}/users/investors/follow/advisor`,
    byCall: `${environment.APIBaseUrl}/calls/investors/add_call`,
    clientList: `${environment.APIBaseUrl}/clients/advisors/list`,
    clientCalls: `${environment.APIBaseUrl}/clients/advisors/calls/list`,
    rateAdvisor: `${environment.APIBaseUrl}/users/investors/rate/advisor`,
    marketResponse: `${environment.APIBaseUrl}/calls/investors/market_response`,
    graphData: `${environment.APIBaseUrl}/calls/investors/dashboard/graph_data/calls`,
    clientReviews: `${environment.APIBaseUrl}/clients/advisors/rating/reviews`,
    logout: `${environment.APIBaseUrl}/users/investors/logout`,
    brokerage: `${environment.APIBaseUrl}/users/investors/brokerage/options`,
    admin_alert: `${environment.APIBaseUrl}/notifications/investors/alert`,
    risk_profile_question: `${environment.APIBaseUrl}/risk_profiling/questions`,
    risk_profile: `${environment.APIBaseUrl}/risk_profiling/profile`,
    clear_closed_call: `${environment.APIBaseUrl}/calls/investors/dashboard/remove/watched/closed/calls`,
    calls_count: `${environment.APIBaseUrl}/calls/investors/dashboard/count/calls`,
    strategic_newCall: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/new/calls`,
    strategic_myCall: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/my/calls`,
    strategic_closedCall: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/closed/calls`,
    strategic_watchCall: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/watch/calls`,
    buy_startegic_call: `${environment.APIBaseUrl}/strategic_calls/investors/add_strategic_calls`,
    topAdvisors: `${environment.APIBaseUrl}/user_dashboard_analytics/investors/top/performers`,
    watchCall_stat: `${environment.APIBaseUrl}/user_dashboard_analytics/investors/watch_calls/stats`,
    filter_count: `${environment.APIBaseUrl}/user_dashboard_analytics/investors/new_calls/count`,
    journey: `${environment.APIBaseUrl}/users/investors/journey`,
    unseenCount: `${environment.APIBaseUrl}/notifications/investors/unseen/call/count`,
    whatsapp: `${environment.APIBaseUrl}/users/whatsapp`,
    resetChatMsg: `${environment.APIBaseUrl}/notifications/investors/chat/call/reset`,
    watchCall_stat_strategy: `${environment.APIBaseUrl}/user_dashboard_analytics/investors/watch_calls/stats/strategy`,
    clear_closed_call_strategy: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/remove/watched/closed/calls`,
    resetChatMsg_strategy: `${environment.APIBaseUrl}/notifications/investors/chat/call/reset/strategy`,
    unseenStrategyCount: `${environment.APIBaseUrl}/notifications/investors/unseen/call/count/strategy`,
    user_likes: `${environment.APIBaseUrl}/topics/users/investors/likes`,
    userProfile: `${environment.APIBaseUrl}/clients/users`,
    userLikes: `${environment.APIBaseUrl}/clients/users/likes`,
    followingList: `${environment.APIBaseUrl}/users/investors/following/list`,
    followerslist: `${environment.APIBaseUrl}/users/investors/followers/list`,
    check_subscription: `${environment.APIBaseUrl}/users/investors/subscription-details`
  },
  ADVISOR: {
    users: `${environment.APIBaseUrl}/users/advisors`,
    upload: `${environment.APIBaseUrl}/users/advisors/upload`,
    uploaddocs: `${environment.APIBaseUrl}/users/advisors/upload/docs`,
    deletedocs: `${environment.APIBaseUrl}/users/advisors/delete/docs`,
    email: `${environment.APIBaseUrl}/users/advisors/email`,
    emailVerify: `${environment.APIBaseUrl}/users/advisors/email/verify`,
    mobile: `${environment.APIBaseUrl}/users/advisors/mobile`,
    verifyMobile: `${environment.APIBaseUrl}/users/advisors/mobile/verify`,
    password: `${environment.APIBaseUrl}/users/advisors/change/password`,
    calls: `${environment.APIBaseUrl}/calls/advisors`,
    instrument: `${environment.APIBaseUrl}/instruments`,
    dashboard: `${environment.APIBaseUrl}/calls/advisors/dashboard`,
    bankDetail: `${environment.APIBaseUrl}/users/advisors/search/ifsc`,
    setupCallCategory: `${environment.APIBaseUrl}/users/advisors/setup/call_category`,
    paymentDetail: `${environment.APIBaseUrl}/payment_remittance/advisors/detail`,
    callwisePayment: `${environment.APIBaseUrl}/payment_remittance/advisors/call_wise_transactions`,
    bankwisePayment: `${environment.APIBaseUrl}/payment_remittance/advisors/bank_transactions`,
    graphData: `${environment.APIBaseUrl}/calls/advisors/dashboard/graph_data/calls`,
    logout: `${environment.APIBaseUrl}/users/advisors/logout`,
    admin_alert: `${environment.APIBaseUrl}/notifications/advisors/alert`,
    unlocked_investors: `${environment.APIBaseUrl}/calls/advisors/dashboard/investor/details`,
    strategy_unlocked_investors: `${environment.APIBaseUrl}/strategic_calls/advisors/dashboard/investor/details`,
    complaints: `${environment.APIBaseUrl}/users/advisors/complaint`,
    client_complaints: `${environment.APIBaseUrl}/clients/advisors/complaint`,
    scripInvestment: `${environment.APIBaseUrl}/calls/advisors/investment/value`,
    whatsapp: `${environment.APIBaseUrl}/users/whatsapp`,
    commodity_instrument: `${environment.APIBaseUrl}/instruments/commodity/options`,
    strategy_payments: `${environment.APIBaseUrl}/payment_remittance/advisors/strategic_call_wise_transactions`,
    trading_LTP: `${environment.APIBaseUrl}/market_socket/kite/quotes`,
    profit_probability: `${environment.APIBaseUrl}/calls/advisors/profit/probability`,
    call_price: `${environment.APIBaseUrl}/calls/advisors/price/setup`,
    market_instrument: `${environment.APIBaseUrl}/instruments/market/watch`,
    user_likes: `${environment.APIBaseUrl}/topics/users/advisors/likes`,
    userProfile: `${environment.APIBaseUrl}/clients/users`,
    userLikes: `${environment.APIBaseUrl}/clients/users/likes`,
    followingList: `${environment.APIBaseUrl}/users/advisors/following/list`,
    followerslist: `${environment.APIBaseUrl}/users/advisors/followers/list`,
    create_bankData: `${environment.APIBaseUrl}/users/advisors/create/ifsc`,
    trade_count: `${environment.APIBaseUrl}/calls/investors/dashboard/trade/count`
  },
  WALLET: {
    addAmount: `${environment.APIBaseUrl}/wallets`,
    walletAmount: `${environment.APIBaseUrl}/wallets/amount`,
    transactions: `${environment.APIBaseUrl}/wallets/transactions`,
    rewards: `${environment.APIBaseUrl}/wallets/rewards/cards`,
    signUp: `${environment.APIBaseUrl}/wallets/rewards/cards/signup`,
    referral: `${environment.APIBaseUrl}/wallets/referral/transactions`,
    referralEmailInvite: `${environment.APIBaseUrl}/users/share`,
    referral_amt: `${environment.APIBaseUrl}/rewards`,
    payout: `${environment.APIBaseUrl}/razorpay/payouts `,
    referral_credits: `${environment.APIBaseUrl}/wallets/rewards/cards/referral_credits`,
    my_rewards: `${environment.APIBaseUrl}/wallets/referral-tasks`,
    referral_details: `${environment.APIBaseUrl}/wallets/referral-details`,
    transaction_details: `${environment.APIBaseUrl}/wallets/referral-transaction-details`,
    referral_summary: `${environment.APIBaseUrl}/wallets/get-referral-summary`,
    mutiple_payout: `${environment.APIBaseUrl}/razorpay/payouts/create-multiple`
  },
  KITE: {
    kite: `${environment.APIBaseUrl}/kite/urls`,
    requestToken: `${environment.APIBaseUrl}/kite/request_token`,

  },
  ALERT: {
    instrument: `${environment.APIBaseUrl}/instruments`,
    alert: `${environment.APIBaseUrl}/alerts/investors/scripts`,
    alertScriptcount: `${environment.APIBaseUrl}/alerts/investors/scripts/counts`,
    admin_alert: `${environment.APIBaseUrl}/notifications/advisors`,
    search_alert: `${environment.APIBaseUrl}/instruments/search/alert`,
  },
  VERSION: {
    version: `${environment.APIBaseUrl}/clients/version`,
  },
  NOTIFICATION: {
    advisor: `${environment.APIBaseUrl}/notifications/advisors`,
    advisorCount: `${environment.APIBaseUrl}/notifications/advisors/activity/count`,
    investor: `${environment.APIBaseUrl}/notifications/investors`,
    investorCount: `${environment.APIBaseUrl}/notifications/investors/activity/count`,
    advisorDashboardAlert: `${environment.APIBaseUrl}/notifications/advisors/dashboard_alert`,
    investorDashboardAlert: `${environment.APIBaseUrl}/notifications/investors/dashboard_alert`,
  },
  RELATIONAL_MANAGER: {
    send_msg: `${environment.APIBaseUrl}/communications/rm/email`,
    rm_details: `${environment.APIBaseUrl}/users/admin/rm_details`,
  },
  CHAT: {
    chat: `${environment.APIBaseUrl}/communications/chat`,
    chatImage: `${environment.APIBaseUrl}/communications/chat/upload/image`,
    investPackChat: `${environment.APIBaseUrl}/communications/wealthcase_chat`,
  },
  FIREBASE: {
    dynamic_link: `${environment.APIBaseUrl}/clients/firebase`,
  },
  STRATEGICCALLS: {
    ADVISOR: {
      strategy: `${environment.APIBaseUrl}/strategic_calls/advisors/strategy`,
      strategic_calls: `${environment.APIBaseUrl}/strategic_calls/advisors/strategic_calls`,
      publishStrategy: `${environment.APIBaseUrl}/strategic_calls/advisors/strategy/publish/strategy`,
      ongoing: `${environment.APIBaseUrl}/strategic_calls/advisors/dashboard/ongoing/calls`,
      history: `${environment.APIBaseUrl}/strategic_calls/advisors/dashboard/history/calls`,
      pending: `${environment.APIBaseUrl}/strategic_calls/advisors/strategy/pending`,
      close: `${environment.APIBaseUrl}/strategic_calls/advisors/strategy/close/strategy`,
    },
    INVESTOR: {
      strategy: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/my/calls`,
      closed_strategy: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/closed/calls`,
      watch_strategy: `${environment.APIBaseUrl}/strategic_calls/investors/dashboard/watch/calls`,
    },
  },
  FORGOTPASSWORD: {
    forgot: `${environment.APIBaseUrl}/users/forgot_password`,
  },
  CLIENTS: {
    advisors: `${environment.APIBaseUrl}/clients/advisors/list`,
    performanceStatistics: `${environment.APIBaseUrl}/clients/advisors/performance_statistics`,
    advisorAnalytics: `${environment.APIBaseUrl}/user_dashboard_analytics/advisors`,
    brokerage_houses: `${environment.APIBaseUrl}/clients/features/brokerage_houses/web`,
    events: `${environment.APIBaseUrl}/analytics/events`,
    calls: `${environment.APIBaseUrl}/clients/calls`,
    videos: `${environment.APIBaseUrl}/clients/global_videos`,
    marketDetail: `${environment.APIBaseUrl}/clients/market/indices/details`,
    topAdvisors: `${environment.APIBaseUrl}/clients/advisors/top_advisors`,
    popularMutualFunds: `${environment.APIBaseUrl}/clients/mutual_fund/schemes`,
    investpacks: `${environment.APIBaseUrl}/clients/wealthcase/list/portfolio`,
    verticals: `${environment.APIBaseUrl}/clients/features/verticals`,
    rewards: `${environment.APIBaseUrl}/clients/rewards/rfd_enabled`,
    coupon_reward: `${environment.APIBaseUrl}/clients/rewards/coupon-details`,
    advisorInfo: `${environment.APIBaseUrl}/userverse/investor/advisor/info`,
    advisorTopThreePack: `${environment.APIBaseUrl}/userverse/investor/advisor/topthreepack`,
    complaindDetail: `${environment.APIBaseUrl}/userverse/investor/advisor/complaints/details`,
    documents: `${environment.APIBaseUrl}/userverse/disclosure/view/document`,
    advisorPerformance: `${environment.APIBaseUrl}/userverse/investor/advisor/investpacks/performance`,
  },
  BLOGS: {
    blogs: `${environment.APIBaseUrl}/blogs`,
    media: `${environment.APIBaseUrl}/blogs/upload/media`,
    allBlogs: `${environment.APIBaseUrl}/clients/blogs`,
    approval: `${environment.APIBaseUrl}/blogs/send/approval`,
    hotTopic: `${environment.APIBaseUrl}/clients/blogs/hot-topics`,
    search: `${environment.APIBaseUrl}/clients/blogs/search`
  },
  PREDICTIONS: {
    prediction: `${environment.APIBaseUrl}/predictions/advisor_views`,
    client: `${environment.APIBaseUrl}/clients/advisors/prediction`,
    upload: `${environment.APIBaseUrl}/predictions/advisor_views/upload/media`,
    predict_date: `${environment.APIBaseUrl}/predictions/advisor_views/get/date`,
    video_predictions: `${environment.APIBaseUrl}/clients/advisors/prediction/uploaded/videos`,
    community_views: `${environment.APIBaseUrl}/predictions/community_views/nifty`,
  },
  NEWS: {
    news: `${environment.APIBaseUrl}/clients/news/articles`,
  },
  MW: {
    market_watch: `${environment.APIBaseUrl}/market_watch`,
  },
  DISCUSSION: {
    topics: `${environment.APIBaseUrl}/topics`,
    topicsMedia: `${environment.APIBaseUrl}/topics/upload/media`,
    sentiment: `${environment.APIBaseUrl}/topics/sentiments`,
    communitySentiment: `${environment.APIBaseUrl}/topics/sentiments/community`,
    post: `${environment.APIBaseUrl}/topics/posts`,
    postMedia: `${environment.APIBaseUrl}/topics/posts/upload/media`,
    postLikeUnlike: `${environment.APIBaseUrl}/topics/posts/likes_unlikes`,
    postById: `${environment.APIBaseUrl}/topics/posts/by_id`,
    postComment: `${environment.APIBaseUrl}/topics/posts/comment`,
    commentLikeUnlike: `${environment.APIBaseUrl}/topics/posts/comment/likes_unlikes`,
    investorPost: `${environment.APIBaseUrl}/topics/users/investors/posts`,
    advisorPost: `${environment.APIBaseUrl}/topics/users/advisors/posts`,
    delete_post: `${environment.APIBaseUrl}/topics/posts`,
    most_discussed: `${environment.APIBaseUrl}/topics/all/posts`,
    investor_topic: `${environment.APIBaseUrl}/topics/users/investors/topics`,
    advisor_topic: `${environment.APIBaseUrl}/topics/users/advisors/topics`,
    topicByInstrument: `${environment.APIBaseUrl}/topics/instrument`,
    topic_cmp: `${environment.APIBaseUrl}/market_socket/kite/quotes`,
  },
  VIDEOS: {
    videos: `${environment.APIBaseUrl}/topics/posts`,
    upload_video: `${environment.APIBaseUrl}/topics/posts/upload/media`,
    comment_video: `${environment.APIBaseUrl}/topics/posts/comment`,
    like_unlike: `${environment.APIBaseUrl}/topics/posts/likes_unlikes`,
    all_videos: `${environment.APIBaseUrl}/topics/posts/all/videos`,
    topic: `${environment.APIBaseUrl}/topics`,
    like_unlike_comment: `${environment.APIBaseUrl}/topics/posts/comment/likes_unlikes`,
    tag_users: `${environment.APIBaseUrl}/topics/posts/tag/users`,
    post_Id: `${environment.APIBaseUrl}/topics/posts/by_id`,
    advisor_video: `${environment.APIBaseUrl}/topics/users/advisors/videos`,
    investor_video: `${environment.APIBaseUrl}/topics/users/investors/videos`,
    upload_base64_video: `${environment.APIBaseUrl}/topics/posts/upload/base64_format`,
    topicWise: `${environment.APIBaseUrl}/topics/posts/videos/topicwise`,
    recent_topics: `${environment.APIBaseUrl}/topics/posts/recent/videos`,
    delete_topic: `${environment.APIBaseUrl}/topics/posts`,
    watch_video: `${environment.APIBaseUrl}/topics/posts/views_count`,
    video_views: `${environment.APIBaseUrl}/clients/users/view_counts`,
  },
  SL: {
    googleDecode: `${environment.APIBaseUrl}/social_signin/google/decode`,
    googleSignIn: `${environment.APIBaseUrl}/social_signin/google/signin`,
    socialLogin: `${environment.APIBaseUrl}/social_signin/login`,
    google: `${environment.APIBaseUrl}/social_signin/google`,
  },
  CONTEST: {
    participants: `${environment.APIBaseUrl}/contest/participants/contests`,
    top_stock: `${environment.APIBaseUrl}/contest/participants/top_stocks`,
    market_nifty: `${environment.APIBaseUrl}/contest/participants/market_nifity`,
    config: `${environment.APIBaseUrl}/contest/admin/config`,
    history: `${environment.APIBaseUrl}/contest/participants/user`,
    winning: `${environment.APIBaseUrl}/contest/participants/winner`,
    claimPrice: `${environment.APIBaseUrl}/wallets/rewards/cards`,
    addStocks: `${environment.APIBaseUrl}/contest/participants/top_stocks/api/v2`,
    addStocksWithSymbolExchange: `${environment.APIBaseUrl}/symbol_price_generator/ticks/contest`
  },
  MUTUALFUND: {
    master: `${environment.APIBaseUrl}/bsestarmf/investor/masters`,
    pack: `${environment.APIBaseUrl}/bsestarmf/investor/pack`,
    sipOrder: `${environment.APIBaseUrl}/bsestarmf/orders/xsip/investment`,
    lumpsumOrder: `${environment.APIBaseUrl}/bsestarmf/orders/lumpsum/investment`,
    amc: `${environment.APIBaseUrl}/bsestarmf/investor/amc`,
    graph: `${environment.APIBaseUrl}/bsestarmf/graph/nav`,
    payments: `${environment.APIBaseUrl}/bsestarmf/payments`,
    square_off: `${environment.APIBaseUrl}/bsestarmf/orders/redemption/order`,
    category: `${environment.APIBaseUrl}/bsestarmf/investor/category`,
    schemeCategory: `${environment.APIBaseUrl}/bsestarmf/investor/display_category`,
    packOrder: `${environment.APIBaseUrl}/bsestarmf/orders/lumpsum/investment`,
    transaction_details: `${environment.APIBaseUrl}/bsestarmf/orders`,
    xsipInvestment: `${environment.APIBaseUrl}/bsestarmf/orders/xsip/investment`,
    xsipOrderHistory: `${environment.APIBaseUrl}/bsestarmf/orders/transaction/history`,
    mandeteLink: `${environment.APIBaseUrl}/bsestarmf/orders/mandate/links`,
    mandeteStatus: `${environment.APIBaseUrl}/mandate/regs`,
    filter_list: `${environment.APIBaseUrl}/mutualfunds/investments/schemes`,
    sipmandeteStatus: `${environment.APIBaseUrl}/bsestarmf/orders/mandate/regs`,
    mfCategories: `${environment.APIBaseUrl}/mutualfunds/categories`,
    performance: `${environment.APIBaseUrl}/mutualfunds/schemes/performance`,
    holdings: `${environment.APIBaseUrl}/mutualfunds/schemes/holdings`,
    details: `${environment.APIBaseUrl}/mutualfunds/schemes/details`,
    calculator: `${environment.APIBaseUrl}/mutualfunds/calculator/investments`,
  },
  INVESTOR_LONGTERM: {
    customised_portfolio: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio/customized/product`,
    portfolio: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio`,
    subscribe: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions`,
    calculation: `${environment.APIBaseUrl}/wealthcase/long_term/calculations/investor/investments`,
    invest: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments`,
    advisor_complaint: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio/advisor/complaint`,
    graph: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio/performance/graph`,
    sip: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio/sip/date`,
    dashboard_rebalance: `${environment.APIBaseUrl}/wealthcase/long_term/investors/dashboard/rebalancing`,
    dashboard_stats: `${environment.APIBaseUrl}/wealthcase/long_term/investors/dashboard/statistics`,
    performanceNifty_graph: `${environment.APIBaseUrl}/wealthcase/long_term/investors/dashboard/performance/graph`,
    order_details: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/orders/details`,
    unSubscribe: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions/unsubscribe/portfolio`,
    rebalance: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/rebalance`,
    order_history: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/orders/history`,
    holdings: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/order/holdings`,
    dash_search: `${environment.APIBaseUrl}/clients/mutual_fund/stock_scheme`,
    investPack_graph: `${environment.APIBaseUrl}/investpack/investpack/growth`,
    external_investment: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/external/orders`,
    retry_orders: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/retry/orders`,
    external_rebal_order: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/external/orders/rebalance`,
    square_off_holding: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/square_off/stock`,
    send_to_whatsapp: `${environment.APIBaseUrl}/wealthcase/long_term/investors/whatsapp`,
    square_off_zerodha: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/external/square_off/stock`,
    rating: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio/rating/packs`,
    ratingReview: `${environment.APIBaseUrl}/clients/wealthcase/rating/reviews`,
    investment_details: `${environment.APIBaseUrl}/investpack/investpack/subscription/investments/info`,
    rebalance_details: `${environment.APIBaseUrl}/wealthcase/long_term/calculations/investor/rebalancing`,
    client_portfolio: `${environment.APIBaseUrl}/clients/wealthcase/list/portfolio`,
    topNews: `${environment.APIBaseUrl}/news/top_news`,
    extrnal_orders: `${environment.APIBaseUrl}/wealthcase/long_term/investors/external_investments`,
    external_rebalanc: `${environment.APIBaseUrl}/wealthcase/long_term/investors/external_investments/rebalance`,
    external_holding: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/external/holdings`,
    external_holding_closing_price: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/instruments/closing_price`,
    missed_profit: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/missed/profit`,
    order_status: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/order/status`,
    tags: `${environment.APIBaseUrl}/wealthcase/masters/tags`,
    holdingsFilter: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions/filters/list`,
    holding_transactions: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/order/transactions`,
    all_investpack: `${environment.APIBaseUrl}/wealthcase/long_term/investors/portfolio`,
    update_transaction: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/orders/management`,
    subscription_flow: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions_flow`,
    brokerage_holdings: `${environment.APIBaseUrl}/wealthcase/brokerage-holdings`,
    update_investpack_agreement: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions/update/agreements`,
    fee_break: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions/fee/components`,
    coupons: `${environment.APIBaseUrl}/promotion/wealthcase/investor/coupon`,
    aum_rebalance: `${environment.APIBaseUrl}/wealthcase/longterm/aum/investor/rebalance`,
    subscribe_aum: `${environment.APIBaseUrl}/wealthcase/longterm/aum/investor/subscribe`,
    aum_rebalance_calculation: `${environment.APIBaseUrl}/wealthcase/longterm/aum/calculation/rebalance`,
    investpack_holdings: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/investpack/holdings/details`,
    free_subscribe: `${environment.APIBaseUrl}/investpack/investpack/subscribe`,
    investpacks_subscriptions: `${environment.APIBaseUrl}/wealthcase/long_term/investors/subscriptions/invpck_subs_invs`,
    order_sync: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/orders/sync`,
    advisor_list: `${environment.APIBaseUrl}/wealthcase/long_term/investors/advisors_list`,
    performanceConsent: `${environment.APIBaseUrl}/wealthcase/long_term/investors/consents`,
    userConsent: `${environment.APIBaseUrl}/wealthcase/long_term/investors/consents/user_consents`,
    newRebalanceHistory: `${environment.APIBaseUrl}/investpack/pack/rebalance/history`,
    criticalUpdates: `${environment.APIBaseUrl}/investpack/pack/critical/updates`,
    subscription_details: `${environment.APIBaseUrl}/investpack/pack-details/subscription`,
    sell: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/exit`,
    couponById: `${environment.APIBaseUrl}/investpack/pack/get-subscription`,
    acceptPerformanceConsentForInvestpackList: `${environment.APIBaseUrl}/wealthcase/long_term/investors/consents/v2`,
    getPerformanceConsentForInvestpackList: `${environment.APIBaseUrl}/wealthcase/long_term/investors/consents/v2`,
    getAumExitFee: `${environment.APIBaseUrl}/investpack/pack-details/aum/exit/fee`,
    getLastTransaction: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/investpack/lastTransaction`,
    factsheetDownload: `${environment.APIBaseUrl}/reportsv2/client/fetch/factsheet`
  },
  ADVISORLONGTERM: {
    portfolio: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio`,
    portfolioImage: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio/upload/image`,
    portfolioState: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio/state/change`,
    calculateWeight: `${environment.APIBaseUrl}/wealthcase/long_term/calculations/advisor/investments`,
    dashboardStatistic: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/dashboard`,
    plans: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/plans`,
    updateInstruments: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio/update/instruments`,
    rebalanceInstruments: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio/rebalancing/instruments`,
    stateChange: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio/state/change`,
    performanceGraph: `${environment.APIBaseUrl}/investpack/investpack/growth`,
    subscribers: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/subscribers`,
    subscriberDetail: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/subscribers/user/details`,
    subscriberSubscription: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/subscription`,
    paymentDetails: `${environment.APIBaseUrl}/payment_remittance/advisors/portfolio/payments/detail`,
    paymentPortfolioWiseDetails: `${environment.APIBaseUrl}/payment_remittance/advisors/portfolio/payments/portfolio_wise_transactions`,
    paymentBankWiseDetails: `${environment.APIBaseUrl}/payment_remittance/advisors/portfolio/payments/bank_transactions`,
    investmentDate: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/portfolio/suggesting/investments`,
    in_app_purchase: `${environment.APIBaseUrl}/wealthcase/long_term/advisors/in_app_purchase`,
    tag: `${environment.APIBaseUrl}/wealthcase/masters/tags`,
    lable: `${environment.APIBaseUrl}/wealthcase/masters/labels`
  },
  BSE: {
    kyc_status: `${environment.APIBaseUrl}/kyc/status`,
    investor_detail: `${environment.APIBaseUrl}/bsestarmf/accounts`,
    pinCode: `${environment.APIBaseUrl}/bsestarmf/pincode`,
    uploadDocument: `${environment.APIBaseUrl}/bsestarmf/accounts/upload/documents`,
    downloadForm: `${environment.APIBaseUrl}/bsestarmf/accounts/download/form`,
    createAccount: `${environment.APIBaseUrl}/bsestarmf/accounts/create/account`,
    consentAgreement: `${environment.APIBaseUrl}/consent/agreements`,
    pdfSignature: `${environment.APIBaseUrl}/bsestarmf/accounts/pdf/signature`,
    pdfUpload: `${environment.APIBaseUrl}/bsestarmf/accounts/upload/pdf`,
    bankName: `${environment.APIBaseUrl}/bsestarmf/investor/bank_name`,
    validate_penny_drop: `${environment.APIBaseUrl}/penny-drop/validate-bank`,
    penny_drop_details: `${environment.APIBaseUrl}/penny-drop/details`,
    upi_payment: `${environment.APIBaseUrl}/bsestarmf/payments/upi`
  },
  KLEVER_TRADE: {
    signinWith: `${environment.APIBaseUrl}/klever_trade/signin`,
    loginWith: `${environment.APIBaseUrl}/klever_trade/login`,
    client: `${environment.APIBaseUrl}/klever_trade/client`,
    placeOrder: `${environment.APIBaseUrl}/klever_trade/orders`,
    token_info: `${environment.APIBaseUrl}/klever_trade/jwt`,
    strategy_order: `${environment.APIBaseUrl}/klever_trade/orders/strategic`,
  },
  PIGGY_BANK: {
    mf_details: `${environment.APIBaseUrl}/mutualfunds/digital-savings/mutual-fund`,
    gold_details: `${environment.APIBaseUrl}/mutualfunds/digital-savings/gold`,
    total_savings: `${environment.APIBaseUrl}/mutualfunds/digital-savings/total-saving`
  },
  ZERODHA: {
    signinWith: `${environment.APIBaseUrl}/zerodha/signin`,
    loginWith: `${environment.APIBaseUrl}/zerodha/login`,
    client: `${environment.APIBaseUrl}/zerodha/urls`,
    placeOrder: `${environment.APIBaseUrl}/zerodha/orders`,
    token_info: `${environment.APIBaseUrl}/zerodha/jwt`,
    strategy_order: `${environment.APIBaseUrl}/zerodha/orders/strategic`,
    callback: `${environment.APIBaseUrl}/zerodha/callback`,
    user_details: `${environment.APIBaseUrl}/zerodha/useprofile`,
    bracket_order: `${environment.APIBaseUrl}/zerodha/orders/bracket`,
    investpack_order_details: `${environment.APIBaseUrl}/wealthcase/long_term/investors/investments/zerodha/orders`,
    trading_order_details: `${environment.APIBaseUrl}/wealthcase/short_term/investors/investments/zerodha/orders`,
    basket: 'https://kite.zerodha.com/connect/basket'
  },
  COMMON: {
    money_control: `${environment.APIBaseUrl}/google/money_control/create`,
  },
  ADITYA_BIRLA: {
    signinWith: `${environment.APIBaseUrl}/adityabirla/signin`,
    loginWith: `${environment.APIBaseUrl}/adityabirla/login`,
    client: `${environment.APIBaseUrl}/adityabirla/client`,
    placeOrder: `${environment.APIBaseUrl}/adityabirla/orders`,
    token_info: `${environment.APIBaseUrl}/adityabirla/jwt`,
    strategy_order: `${environment.APIBaseUrl}/adityabirla/orders/strategic`
  },
  EDELWEISS: {
    signinWith: `${environment.APIBaseUrl}/nuvama/signin`,
    signinWithV2: `${environment.APIBaseUrl}/nuvama/signin/v2`,
    loginWith: `${environment.APIBaseUrl}/nuvama/login`,
    client: `${environment.APIBaseUrl}/nuvama/client`,
    placeOrder: `${environment.APIBaseUrl}/nuvama/orders`,
    // token_info: `${environment.APIBaseUrl}/nuvama/userdetails`,
    strategy_order: `${environment.APIBaseUrl}/nuvama/orders/strategic`
  },
  RAZORPAY: {
    bank_account: `${environment.APIBaseUrl}/razorpay/fund_accounts`,
    payouts: `${environment.APIBaseUrl}/razorpay/payouts`
  },
  ANGELBROKING: {
    signinWith: `${environment.APIBaseUrl}/angel_broking/signin`,
    loginWith: `${environment.APIBaseUrl}/angel_broking/login`,
    client: `${environment.APIBaseUrl}/angel_broking/client`,
    placeOrder: `${environment.APIBaseUrl}/angel_broking/orders`,
    token_info: `${environment.APIBaseUrl}/angel_broking/jwt`,
    strategy_order: `${environment.APIBaseUrl}/angel_broking/orders/strategic`
  },
  BAJAJFINANCE: {
    signinWith: `${environment.APIBaseUrl}/bajajfinserv/signin`,
    loginWith: `${environment.APIBaseUrl}/bajajfinserv/login`,
    client: `${environment.APIBaseUrl}/bajajfinserv/client`,
    placeOrder: `${environment.APIBaseUrl}/bajajfinserv/orders`,
    token_info: `${environment.APIBaseUrl}/bajajfinserv/jwt`,
    bracket_order: `${environment.APIBaseUrl}/bajajfinserv/orders/bracket`,
    strategy_order: `${environment.APIBaseUrl}/bajajfinserv/orders/strategic`
  },
  TERMS_CONDITIONS: {
    terms: `${environment.APIBaseUrl}/clients/terms_conditions`
  },
  TRANSACTIONS: {
    transaction: `${environment.APIBaseUrl}/payment-gateway/transaction`,
    transaction_status: `${environment.APIBaseUrl}/payment-gateway/transaction/payment/status`,
    invoice: `${environment.APIBaseUrl}/payment-gateway/invoice`,
    getInvoice: `${environment.APIBaseUrl}/document-service/userInvoice/invoice/investor`
  },
  PAYMENT_GATEWAY: {
    verfiy_payment: `${environment.APIBaseUrl}/payment-gateway/transaction/verify`,
    failed_payment: `${environment.APIBaseUrl}/payment-gateway/transaction/failed`
  },
  KYC: {
    kyc_pan: `${environment.APIBaseUrl}/kyc/pan-verification`,
    kyc_download: `${environment.APIBaseUrl}/kyc/download`
  },
  ESIGN: {
    sign_RA: `${environment.APIBaseUrl}/consent/agreements/sign/ra/v3`,
    sign_RIA: `${environment.APIBaseUrl}/consent/agreements/sign/ria/v3`,
    status_RA: `${environment.APIBaseUrl}/consent/agreements/status/ra`,
    status_RIA: `${environment.APIBaseUrl}/consent/agreements/status/ria/v3`,
    extend_agreement: `${environment.APIBaseUrl}/consent/agreements/sign/aum`
  },
  POPUP_BANNER: {
    popup_banner: `${environment.APIBaseUrl}/alerts/popup-banner`
  },
  CAMPAIGN: {
    visitor_count: `${environment.APIBaseUrl}/promotion/campaign/update-visitor`,
    signup_subscribe_count: `${environment.APIBaseUrl}/promotion/campaign/update-signup-subscription`,
    check_campaign: `${environment.APIBaseUrl}/promotion/campaign/campaign_name`
  },
  AUM_BILLING: {
    bill_info: `${environment.APIBaseUrl}/aumbilling/investor/billInfo`,
    bill_detail: `${environment.APIBaseUrl}/aumbilling/investor/billdetails`,
    monthly_bill: `${environment.APIBaseUrl}/aumbilling/investor/monthlybill`,
    unsettled_bill: `${environment.APIBaseUrl}/aumbilling/investor/unsettledBill`,
    calculateInvestment: `${environment.APIBaseUrl}/investpack/investpack/aum/investment/calculate/fee`,
    additional_payment: `${environment.APIBaseUrl}/investpack/investpack/aum/investment/fee`
  },
  CALLS: {
    advisor_calls: `${environment.APIBaseUrl}/venus/investor/get-calls`,
    call_details: `${environment.APIBaseUrl}/venus/investor/call-details`,
    shortlist_call: `${environment.APIBaseUrl}/venus/profile/shortlist`,
    call_graph: `${environment.APIBaseUrl}/calls/investors/dashboard/graph_data/calls`,
    top_calls: `${environment.APIBaseUrl}/venus/investor/top-calls`,
    trade_calls: `${environment.APIBaseUrl}/wealthcase/short_term/investors/Investments`,
    traded_calls: `${environment.APIBaseUrl}/calls/investors/dashboard/trade/calls`,
    dashboard_data: `${environment.APIBaseUrl}/calls/investors/dashboard/trade/details`,
    trade_orders: `${environment.APIBaseUrl}/wealthcase/short_term/investors/Investments`,
    dash_closed_calls: `${environment.APIBaseUrl}/venus/advisor-details/top-closed-calls`,
    calls_count: `${environment.APIBaseUrl}/calls/investors/dashboard/count/calls`,
    scrip_accuracy: `${environment.APIBaseUrl}/venus/advisor-details/script-accuracy`,
    recent_calls: `${environment.APIBaseUrl}/venus/investor/recent-calls`
  },
  TRADING_ADVISOR: {
    top_3_advisors: `${environment.APIBaseUrl}/venus/advisor-details/top`,
    high_return_advisors: `${environment.APIBaseUrl}/venus/advisor-details/high-return`,
    popular_advisors: `${environment.APIBaseUrl}/venus/advisor-details/popular`,
    good_performer_advisors: `${environment.APIBaseUrl}/venus/advisor-details/popular`,
    all_advisors: `${environment.APIBaseUrl}/venus/advisor-details/get-advisors`,
    pack_previous_call: `${environment.APIBaseUrl}/venus/advisor-details/previous-calls`,
    pack_closed_call: `${environment.APIBaseUrl}/venus/investor/trading-packs/closed-calls`,
    advisors_details: `${environment.APIBaseUrl}/venus/advisor-details`,
    advisor_performance: `${environment.APIBaseUrl}/venus/advisor-details/advisor-performance`,
    subscribed_list: `${environment.APIBaseUrl}/venus/investor/get-subscribed-advisors`,
    search_advisor: `${environment.APIBaseUrl}/venus/advisor-details/search`,
    advisor_rating: `${environment.APIBaseUrl}/users/investors/rate/advisor`,
    advisor_closed_calls: `${environment.APIBaseUrl}/venus/advisor-details/closed-calls`,
    advisor_subscription: `${environment.APIBaseUrl}/venus/advisor/get-subscription`,
    subscription_flow: `${environment.APIBaseUrl}/venus/profile/subscriptionFlowState`,
    sign_RA: `${environment.APIBaseUrl}/consent/agreements/trade/ra/v3`,
    sign_RIA: `${environment.APIBaseUrl}/consent/agreements/trade/ria/v3`,
    subscribe_advisor: `${environment.APIBaseUrl}/venus/profile/subscribe`,
    closed_call_details: `${environment.APIBaseUrl}/venus/investor/closed-call-details`,
    closed_call_comment: `${environment.APIBaseUrl}/clients/calls/messages`,
    advisor_review: `${environment.APIBaseUrl}/clients/advisors/rating/reviews`,
    coupon: `${environment.APIBaseUrl}/promotion/trading-advisory/investor/coupon`,
    advisor_reviewed: `${environment.APIBaseUrl}/users/investors/rate/advisor/list`,
    client_detail: `${environment.APIBaseUrl}/adminuniverse/client-config/b2c-client-details`,
    default_advisor: `${environment.APIBaseUrl}/venus/advisor-details/default-advisor-details`,
    default_trading_pack: `${environment.APIBaseUrl}/venus/investor/trading-packs/default`,
    get_suscription_pack: `${environment.APIBaseUrl}/venus/get-subscription/`,
    my_subscription: `${environment.APIBaseUrl}/venus/profile/my-subscription`,
    get_advisor_pack_data: `${environment.APIBaseUrl}/venus/investor/trading-packs/get-advisor-by-pack/`,
    pack_reviewed: `${environment.APIBaseUrl}/venus/trading-packs-rating-review/getByinvestor/`,
    update_reviewed: `${environment.APIBaseUrl}/venus/trading-packs-rating-review/`,
    getAllTradingPack: `${environment.APIBaseUrl}/venus/investor/trading-packs`,
    subscriptionPlanData: `${environment.APIBaseUrl}/venus/advisor/trading-packs/get-subscription/`,
    advisor_detail_data: `${environment.APIBaseUrl}/venus/advisor-details/basic/`,
    advisor_subscribe_pack: `${environment.APIBaseUrl}/venus/advisor-details/all-packs/`,
    pack_details: `${environment.APIBaseUrl}/venus/investor/trading-packs/details/`,
    pack_performance: `${environment.APIBaseUrl}/venus/investor/trading-packs/performance-details`,
    historical_report: `${environment.APIBaseUrl}/venus/investor/trading-packs/report`,
    pack_review: `${environment.APIBaseUrl}/venus/trading-packs-rating-review/`,
    order_history: `${environment.APIBaseUrl}/venus/investor/order-history`,
    holdings: `${environment.APIBaseUrl}/venus/investor/holdings`,
    advisor_list: `${environment.APIBaseUrl}/venus/advisor-details/trading-experts`,
    realized_earning: `${environment.APIBaseUrl}/venus/investor/trading-packs/realized-earning`,
    unrealized_earning: `${environment.APIBaseUrl}/venus/investor/trading-packs/unrealized-earning`,
    current_subscription: `${environment.APIBaseUrl}/venus/profile/current-subscribed-plan`,
    order_sync: `${environment.APIBaseUrl}/wealthcase/short_term/investors/investments/orders/sync`,
    consent_accept: `${environment.APIBaseUrl}/venus/consent/create`,
    consent_detail: `${environment.APIBaseUrl}/venus/consent/details`,
    user_consent: `${environment.APIBaseUrl}/wealthcase/long_term/investors/consents/user_consents`
  },
  OFFERS: {
    offer_config: `${environment.APIBaseUrl}/promotion/admin-offers/get-activity`
  },
  LIVE_FEED: {
    live_feed: `${environment.APIBaseUrl}/adminuniverse/liveFeed/investor/read/feed`
  },
  TRADING_PACK: {
    subscribed_packs: `${environment.APIBaseUrl}/venus/investor/trading-packs/get-subscribed-packs`
  },
  RM_FLOW: {
    linkInfo: `${environment.APIBaseUrl}/rm-service/links/investor`,
    trackLinkInfo: `${environment.APIBaseUrl}/rm-service/links/track`
  },
  VENTURA:{
    client: `${environment.APIBaseUrl}/ventura/ventura/url`,
    getProfile: `${environment.APIBaseUrl}/ventura/ventura/getProfile`,
    basket_details: `${environment.APIBaseUrl}/ventura/ventura/basket-details`,
  },
  KOTAK: {
    login: `${environment.APIBaseUrl}/kotak/v2/kotak-credentials`,
    verifyOtp: `${environment.APIBaseUrl}/kotak/validate-otp`
  },
};
